import ufeApi from 'services/api/ufeApi';
const ATG_URL = '/api/secure/resetPassword';
const AUTH_URL = '/api/auth/v1/resetPassword';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Reset+Password+API

function resetPasswordByLogin(email, source) {
    const { isAuthServiceResetPassEnabled } = Sephora.configurationSettings;

    let URL = ATG_URL;
    let headers = {};

    if (isAuthServiceResetPassEnabled) {
        URL = AUTH_URL;
        headers = {
            'Content-type': 'application/json',
            'x-requested-source': 'web'
        };
    }

    return ufeApi
        .makeRequest(URL, {
            method: 'POST',
            body: JSON.stringify({
                type: 'email',
                email,
                source: source || undefined
            }),
            headers
        })
        .then(data => {
            return data.errorCode || data.errors ? Promise.reject(data) : data;
        })
        .catch(err => Promise.reject(err));
}

function resetPassword(email, password, confirmPassword, securityToken) {
    const { isAuthServiceResetPassEnabled } = Sephora.configurationSettings;

    let URL = ATG_URL;
    let headers = {};

    if (isAuthServiceResetPassEnabled) {
        URL = AUTH_URL;
        headers = {
            'Content-type': 'application/json',
            'x-requested-source': 'web'
        };
    }

    return ufeApi
        .makeRequest(URL, {
            method: 'POST',
            body: JSON.stringify({
                type: 'reset',
                email,
                password,
                confirmPassword,
                securityToken: securityToken
            }),
            headers
        })
        .then(data => {
            return data.errorCode || data.errors ? Promise.reject(data) : data;
        })
        .catch(err => Promise.reject(err));
}

export default {
    resetPasswordByLogin,
    resetPassword
};
